import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";
import BrandedTextElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue";
import BrandedHeadingElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedHeadingElement.vue";
import BrandedSubHeadingElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedSubHeadingElement.vue";
import BrandedTitleElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedTitleElement.vue";
import BrandedLabelElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedLabelElement.vue";
import BrandedParagraphElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedParagraphElement.vue";
import BrandedNoteElement
  from "%/dynamic-component-editor/standard-elements/text-element/BrandedNoteElement.vue";

export default class LegacyTextEntity extends LegacyEntity {

  static get elements() {
    return [
      // Registered (but hidden from the panel via the component's own
      // `hidden: true`) so any existing `BrandedTextElement` entities —
      // created during an earlier unified-text experiment — still
      // resolve to a Vue component and render. New panel drags use the
      // per-style `BrandedXxxElement` variants below.
      BrandedTextElement,
      BrandedHeadingElement,
      BrandedSubHeadingElement,
      BrandedTitleElement,
      BrandedLabelElement,
      BrandedParagraphElement,
      BrandedNoteElement,
    ];
  }
}

